const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) { return '0 Bytes'; }

    const sizesIndex = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / Math.pow(1024, sizesIndex), 2)} ${sizes[sizesIndex]}`;
};

const isTouchDevice = () => (
    !!(typeof window !== 'undefined' && ('ontouchstart' in window || (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))) ||
    !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
);

const keyCode = {
    ENTER: 13,
    SPACE_BAR: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
};

const previewTypes = {
    IMAGE: 'Image',
    VIDEO: 'Video',
    AUDIO: 'Audio',
    TEXT: 'Text',
    PDF: 'Pdf',
    ARCHIVE: 'Archive',
    SPECIAL: 'Special',
    UNKNOWN: 'Unknown'
};

export { bytesToSize, isTouchDevice, keyCode, previewTypes };
